import { APP_CONTEXT } from '@reducers/app/types';
/** Resolves the company of the given app context, kept per context like the removed MST `store.app` split. */
export const selectSearchCompany = (state, context) => state.searchCompany[context] || state.searchCompany[APP_CONTEXT.PROSPECT];
